if (!customElements.get("bundle-verification")) {
  class BundleVerification extends HTMLElement {
    constructor() {
      super();
      this.bundleVariants = [];
      this.enabledRebuyCart = this.getAttribute("data-enabled-rebuy-cart") === "true";
      this.handleRebuyEvent = this.handleRebuyEvent.bind(this);
      this.handleAjaxCartEvent = this.handleAjaxCartEvent.bind(this);
    }

    connectedCallback() {
      this.parseBundleData();
      this.attachListeners();
      this.initialCheck();
    }

    disconnectedCallback() {
      document.removeEventListener("rebuy:cart.ready", this.handleRebuyEvent);
      document.removeEventListener("rebuy:cart.change", this.handleRebuyEvent);
      document.removeEventListener("liquid-ajax-cart:request-end", this.handleAjaxCartEvent);
    }

    parseBundleData() {
      try {
        const raw = this.getAttribute("data-bundle-array");
        this.bundleVariants = raw ? JSON.parse(raw) : [];
      } catch (e) {
        console.error("Invalid bundle data JSON", e);
        this.bundleVariants = [];
      }
    }

    attachListeners() {
      if (this.enabledRebuyCart) {
        document.addEventListener("rebuy:cart.ready", this.handleRebuyEvent);
        document.addEventListener("rebuy:cart.change", this.handleRebuyEvent);
      } else {
        document.addEventListener("liquid-ajax-cart:request-end", this.handleAjaxCartEvent);
      }
    }

    async initialCheck() {
      if (this.enabledRebuyCart) {
        return; 
      } else {
        const cart = await this.getCart();
        await this.checkBundlesInCart(cart);
      }
    }

    async handleRebuyEvent(event) {
      const cart = event?.detail?.cart?.cart;
      await this.checkBundlesInCart(cart);
    }


    async handleAjaxCartEvent() {
      const cart = await this.getCart();
      await this.checkBundlesInCart(cart);
    }

    async getCart() {
      const res = await fetch("/cart.js");
      return await res.json();
    }


    async updateBundleAttribute(cart, value) {
      if (!cart) return;

      const currentValue = cart.attributes?.is_it_bundle === true || cart.attributes?.is_it_bundle === "true";

      if (currentValue === value) return;

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: {
            is_it_bundle: value
          }
        })
      });
    }

    async checkBundlesInCart(cart) {
    if (!cart || !cart.items || !this.bundleVariants.length) return;

    const isBundle = this.bundleVariants.some((bundle) =>
        bundle.every((sku) =>
        cart.items.some((item) => item.sku === sku && item.properties?._is_it_bundle === "true"))
    );

    await this.updateBundleAttribute(cart, isBundle);
    }

  }

  customElements.define("bundle-verification", BundleVerification);
}